export default {
  WHITE_LIST_LIMIT_BATCH: '/internal/policy/updateUsersWhiteWord', // 批量修改白词接口
  BLACK_FILTER_LIMIT_BATCH: '/internal/policy/patchUsersBlackLevel', // 批量修改过滤黑词等级接口
  WHITE_LIST_LIMIT: '/internal/violation/updateUserWhiteWord', // 修改白词接口
  BLACK_FILTER_LIMIT: '/internal/policy/patchUserBlackLevel', // 修改过滤黑词等级接口
  USER_IGNORE_CASE: '/internal/policy/updateUserIgnoreCase', // 是否开启英文大小写转换
  USER_SPECIAL_CHARS: '/internal/policy/updateUserSpecialChars', // 是否开启特殊字符检测
  USER_ABNORMAL_CHARS: '/internal/policy/updateUserSmsAbnormalChars', // 是否开启变体字检测
  USER_CONTINUOUS_NUMBER: '/internal/policy/updateUserSpecialNumCharacter', // 是否开启特殊数字符号检测
  USER_SMS_AMOUNT_MONITOR: '/internal/policy/updateUserSmsAmountMonitor', // 是否开启发送量突增监控开关
  USER_RISK_LEVEL: '/internal/policy/updateUserRiskLevel', // 风险等级配置
  USER_NIGHT_SMS_AMOUNT_MONITOR: '/internal/policy/updateUserNightSmsAmountMonitor', // 是否夜间发送量监控开关
  USER_URL_DEFORMED: '/internal/policy/updateUserUrlDeformed', // 是否开启网址检测
  UPDATE_WEBSITES: '/internal/website/updateWebSites' // 批量更新网址
}
